<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class='h100vh-100'>
        <div class='h-toolbarBg'>
          <ejs-toolbar>
            <e-items>
              <e-item :prefixIcon='subscritionIcon'  :tooltipText='subscritionText' :click='changeTips'></e-item>
            </e-items>
          </ejs-toolbar>
        </div>
        <div class='h100-40 noPage' ref="emapElement">
          
        </div>
          
      </div>
     
    </template>
  </BasicLayout>
</template>

<script>
import L from 'leaflet';
import BasicLayout from '../../../layouts/BasicLayout';
import CustomDialog from '../../../components/common/CustomDialog';
import { EventBus } from '../../../plugins/eventBus';
import { CommandColumn  } from "@syncfusion/ej2-vue-grids";
import iconPonit from '../../../components/subscriberMicro/util/img/marker-icon.png';

export default {
  name: 'eMap',
  provide: {
    
  },
  components: {
    BasicLayout,
    CustomDialog,
  },
  data() {
    return {
      left: { show: false, name: '' },
      middle: { show: false, name: '' },
      right: { show: true, crumb: this.$t('Topo.emap') },
      showTooltip: true,
      map: null,
      curIcon : L.icon({
        iconUrl: iconPonit,
        iconSize: [25, 41],
        iconAnchor: [12.5, 35.5],
      }),
      allBSMarker: [],
      mapConfig:{
        latitude:45.10155039475129,
        longitude:126.53095722198488,
        zoom:13,
        maxZoom:15,
        minZoom:1
      },
    };
  },
  
  methods: {
    async initMap() {
      await this.$axios.post('/lte/ems/sysmanager/map/queryConfig.html').then((response) => {
        const mapConf = response.data;
        this.mapConfig.latitude = mapConf.centerLatitude;
        this.mapConfig.longitude = mapConf.centerLongitude;
        this.mapConfig.zoom = mapConf.defaultZoom;
        this.mapConfig.maxZoom = mapConf.maxZoom;
        this.mapConfig.minZoom = mapConf.minZoom;
        // this.map.setView([this.mapConfig.latitude, this.mapConfig.longitude],this.mapConfig.zoom)
      });
      const webUrl = '/UniNM/map/{z}/{x}/{y}.png';
      const mapLayer = L.tileLayer(webUrl,{maxZoom:this.mapConfig.maxZoom,minZoom:this.mapConfig.minZoom});
      this.map = L.map(this.$refs['emapElement'], {
        layers: [mapLayer],
      }).setView([this.mapConfig.latitude, this.mapConfig.longitude],this.mapConfig.zoom);
      
      
      
    },
    queryAll(){
      const typeCode = '10009,10001,10004';

      this.$axios.get(`/lte/ems/topo/queryEquipmentByTypeCode?typeCode=${typeCode}`).then((response) => {
        if (response && response.status === 200  && response.data.errorCode === 'SUCCESS') {
          response.data.resultVal.forEach((bs =>{
            if(bs.latitude !=null && bs.longitude !=null){
              let location = [parseFloat(bs.latitude), parseFloat(bs.longitude)];
                            
                let bsmarker = L.marker(location, {
                  icon: this.curIcon,
                  draggable: false
                }).bindTooltip("<font color='red'>"+this.$t("Topo.name")+": "+bs.name+"</font></br><font color='red'>"+this.$t("Topo.longitude")+": "+bs.longitude+"</font></br><font color='red'>"+this.$t("Topo.latitude")+": "+bs.latitude+"</font>", {
                  permanent: true,
                  offset: [0, 13],// 偏移
                  direction: "bottom",// 放置位置
                  // sticky:true,//是否标记在点上面
                  className: 'tooltip-font'// CSS控制样式
                }).openTooltip();
                this.map.addLayer(bsmarker);
                this.allBSMarker.push(bsmarker);
              
            }
            
          }))
        }
      });
      
    },
    changeTips(){
        if(this.showTooltip){
          this.allBSMarker.forEach(bs => {
            bs.closeTooltip();
          });
          
          this.showTooltip = false;
        }else{
          this.allBSMarker.forEach(bs => {
            bs.openTooltip();
          });
          this.showTooltip = true;
        }
    },
  },
  mounted() {
    this.initMap();
    this.queryAll();
  },
  computed: {
    subscritionIcon() {
      return this.showTooltip == true ? 'icon hero-icon hero-icon-remove-small' : 'icon hero-icon hero-icon-add-small';
    },
    subscritionText(){
      return this.showTooltip == true? this.$t("Topo.hiddenTips") : this.$t("Topo.showTips");
    }
  },
  created() {
    
  }
  
};
</script>
<style scoped>
@import '~leaflet/dist/leaflet.css';

#mapElement {
width:100%;
height:100vh;
 
}
</style>

